import { Link, TrackingData } from '@ecm/router';

import { Legal } from '../../../business/api/dashboardV7/legal';
import { Tag } from '../../../business/api/dashboardV7/tag';

export class MegapushModel {
    public cid?: string;
    public energy?: string;
    public img161?: string;
    public img162?: string;
    public imgUrl?: string;
    public imgWebMobileUrl?: string;
    public isSosh?: boolean;
    public legal?: Legal;
    public tag?: Tag;
    public text?: string;
    public text2?: string;
    public textColor?: string;
    public title?: string;
    public trackingData?: TrackingData;
    public urlLabel?: string;
    public urlWeb?: Link;

    public constructor(init?: Partial<MegapushModel>) {
        Object.assign(this, init);
    }
}
